import { Box, Text, InfoIcon, ToggleSwitch } from '@wix/design-system';
import React__default from 'react';

const ToggleButton = ({
  checked,
  onChange,
  title,
  infoContent,
  dataHook
}) => {
  return /* @__PURE__ */ React__default.createElement(Box, { verticalAlign: "middle", align: "space-between" }, infoContent ? /* @__PURE__ */ React__default.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React__default.createElement(
    InfoIcon,
    {
      size: "small",
      content: infoContent,
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: 101e3
        // TODO: think of using CSS var, maybe WDS could expose token
      }
    }
  )) : /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React__default.createElement(ToggleSwitch, { checked, onChange, dataHook }));
};

export { ToggleButton };
//# sourceMappingURL=toggle-button.js.map
